import React from 'react';
import { Box, BoxProps, withStyles } from '@material-ui/core';
import { alert } from 'globals/colors';
import cn from 'classnames';
import FsCurrency from 'ui-elements/common-elements/FsCurrency';
import FsCaption from 'ui-elements/typography/FsCaption';
import FsPendingButton from 'ui-elements/buttons/FsPendingButton';
import { FsPendingButtonProps } from 'ui-elements/buttons/FsPendingButton/FsPendingButton';

interface RowBoxProps extends BoxProps {
  isPaid?: boolean;
}

export const RowBox = withStyles(({ spacing, palette }) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: spacing(1, 0),
    '&.noPayment': {
      borderBottom: `1px solid ${palette.grey[200]}`,
      padding: spacing(2, 0),
    },
  },
}))(({ isPaid, ...otherProps }: RowBoxProps) => (
  <Box {...otherProps} className={cn({ noPayment: !isPaid })} />
));

export const DateBox = withStyles(({ spacing }) => ({
  root: {
    minWidth: 210,
    marginRight: spacing(1),
  },
}))(Box);

export const CurrencyBox = withStyles(({ spacing }) => ({
  root: {
    minWidth: 140,
    marginRight: spacing(1),
  },
}))(Box);

export const LinkBox = withStyles(({ spacing }) => ({
  root: {
    marginRight: spacing(4),
  },
}))(Box);

export const Currency = withStyles(({ palette }) => ({
  root: {
    color: palette.grey[400],
  },
}))(FsCurrency);

export const ButtonWrapperBox = withStyles(({ spacing }) => ({
  root: {
    marginTop: spacing(2),
  },
}))(Box);

export const ErrorBox = withStyles(() => ({
  root: {
    color: alert.ERROR,
    '& *': {
      color: alert.ERROR,
    },
  },
}))(Box);

export const ErrorCaption = withStyles(() => ({
  root: {
    fontWeight: 400,
  },
}))(FsCaption);

export const PayButton = withStyles(({ spacing }) => ({
  root: {
    padding: spacing(1, 2.5),
    fontSize: 14,
    borderRadius: 4,
    whiteSpace: 'nowrap',
  },
}))((props: FsPendingButtonProps) => (
  <FsPendingButton {...props} variant="contained" color="primary" />
));
